import React from 'react'
import { Form } from 'react-bootstrap'
import { get } from 'lodash'

const IDSelector = ({
    items = [],
    value = '',
    onChange =() => {},
    size,
    keyField = 'id',
    valueField = 'name',
    placeholder = '',
    style={},
    disabled
}) => {
    const noValueSelected = !value ? { color: '#888' } : {}
    style = {...style, ...noValueSelected}
    return (
        <Form.Control as='select' value={value} onChange={e => onChange(e.target.value)} size={size} style={style} disabled={disabled}>
            <option value=''>{placeholder}</option>
            {items.map((item, k) => (<option value={get(item, keyField)} key={k}>{get(item, valueField)}</option>))}
        </Form.Control>
    )
}

export default IDSelector